<template>
  <div />
</template>

<script>
import { getJsSdkConfig } from '@/api/pay'
import { SOUGOU_WXJSDK_APPID as WXJSDK_APPID } from '@/config/dataMap'
import { WX_SCOPE, wxOauth } from '@/services/pay/wxAuth'
import {
  scanQrReportByService, getH5ReportParamAndcheckCanCreateOrder,
  createMidasOrderByTool, createMidasOrderByStandardPackage
} from '@/api/pdfPay'
import wx from 'weixin-js-sdk'
import { useEasyCounter, useReporter } from '@crab/veekd'

// 支付状态
const PAY_RESULT = {
  enterH5: 3, // 进入H5，
}

// 订单创建状态
const ORDER_STATUS = {
  success: 1, // 成功
  havePay: 2, // 已经购买过该套餐
  isLifeMember: 3, // 已是终生会员，联系工作人员购买
}

// 产品ID
const PRODUCT_ID = {
  pdfVip: 13, // 极光pdf独立版
}

// h5页面加载时长上报版本号
const REPORT_VERSION = '1'

// easyCounter metric
const EASYCOUNTER_METRIC = {
  loadTimeGauge: 'wechat_midas_page_load_time', // 加载时长上报指标
  enterCount: 'wechat_midas_pay_page_count', // 进入页面的次数
}

// sessionStorage参数枚举
const SESSION_STORAGE_PARAMS = {
  isReturn: 'isReturn', // 页面返回
  enterTime: 'enterTime', // 进入时间
}

const PAY_WAY = {
  TOOL: 1, // 道具直购
  STANDARD_MONTHLY: 2, // 标准包月
}

// appid - 搜狗侧提供
const APP_ID = {
  TOOL: '1450356157', // 道具直购
  STANDARD_MONTHLY: '1450341278', // 标准包月
}
/**
 * 移动端中间支付页 - sogou支付接入米大师支付
 */
export default {
  name: 'MidasPay',

  data () {
    return {
      payParams: {}, // 支付的参数
      common: {},
      code: '', // 登录的 WX code,
      certificateId: '', // 套餐凭证ID
      initEnterTime: '', // 首次进入页面的时间
      wx_openid: '', // 微信openid
      openid: '', // 极光PDF的openid
      payWay: PAY_WAY.STANDARD_MONTHLY, // 米大师支付方式
      pidOfMidas: '', // 套餐ID - 服务端返回，传给米大师
      paramUrl: '', // 道具直购的参数
      orderId: '', // 订单ID,
      appid: APP_ID.STANDARD_MONTHLY, // 米大师的应用ID
    }
  },

  async created () {
    // 判断是否是回退
    const isCloseWindow = this.handleIsReturnWindow()
    // 获取微信登录后授权的code， 如果是微信登录这个code会携带过来
    this.code = this.$route.query.code || ''

    /**
     * 回退 - isCloseWindow && !this.code
     * 刷新 - isCloseWindow && this.code
     */
    if (isCloseWindow && !this.code) {
      // 回退
      this.initJsSdkConfig(() => {
        wx.closeWindow()
      })
      return
    }

    try {
      this.cacheTimeOfEnterPage()
      if (this.code) {
        // easyCounter统计进入页面次数
        useEasyCounter().count(EASYCOUNTER_METRIC.enterCount, 1, { tryno: '3068' })

        // 获取凭证ID
        this.certificateId = this.$route.query.cert_id

        // 判断是否支持用户支付该订单
        await this.getCanCreateOrder()
      } else {
        // 不存在微信登录授权的code，走静默登录
        sessionStorage.removeItem(SESSION_STORAGE_PARAMS.isReturn)
        wxOauth(WXJSDK_APPID, WX_SCOPE.base, 'silent')
      }
    } catch (err) {
      console.log('error:', err)
    }
  },

  mounted () {
    document.title = 'PDF编辑转换器 - 微信支付'
  },

  methods: {
    // 判断用户是否被允许支付该套餐
    async getCanCreateOrder () {
      try {
        const res = await getH5ReportParamAndcheckCanCreateOrder({
          certificate: this.certificateId
        })

        if (res.status !== ORDER_STATUS.success) {
          let toastText = '该订单已支付'
          if (res.status === ORDER_STATUS.isLifeMember) {
            toastText = '请联系极光PDF工作人员进行购买'
          }
          this.handleError({ toastText })
        } else {
          this.initReportParams(res)
        }
      } catch (err) {
        console.log('error in judgement:', err)
      }
    },

    /**
     * 初始化上报参数
     */
    initReportParams (res) {
      // @ts-ignore
      const client_extra = res.client_extra
      // 获取上报数据
      this.payParams = client_extra.payParams
      this.common = client_extra.common
      this.payWay = this.payParams?.isTool ? PAY_WAY.TOOL : PAY_WAY.STANDARD_MONTHLY
      this.appid = this.payParams?.isTool ? APP_ID.TOOL : APP_ID.STANDARD_MONTHLY

      // 上报
      this.scanQrReport()

      // 存在微信授权的code
      this.payParams.wx_oauth_code = this.code
      this.createMidasOrder()
    },

    // 数据上报
    async scanQrReport () {
      try {
        await scanQrReportByService({
          ...this.payParams,
          pay_result: String(PAY_RESULT.enterH5),
          common: this.common
        })
      } catch (err) {
        console.log('error in report:', err)
      }
    },

    // 初始化JS-SDK的配置
    async initJsSdkConfig (callback) {
      const { open_id, token, tryno } = this.common
      const res = await getJsSdkConfig({
        common: {
          open_id,
          token,
          tryno
        },
        url: window.location.href
      })

      // 初始化配置信息
      wx.config({
        debug: false,
        appId: WXJSDK_APPID,
        // @ts-ignore
        timestamp: res.timestamp,
        // @ts-ignore
        nonceStr: res.nonceStr,
        // @ts-ignore
        signature: res.signature,
        jsApiList: ['chooseWXPay'],
      })

      // 配置信息验证成功后走ready
      wx.ready(() => {
        // 判断当前客户端版本 是否支持指定的JS接口
        wx.checkJsApi({
          jsApiList: ['chooseWXPay'],
          success: (res) => {
            // 成功执行回调
            callback && callback()
          }
        })
      })
    },

    /**
     * 出错提示方法封装
     * {
     *    toastText: 错误提示文本
     *    toastDuration: toast显示时长
     *    isCloseWindow: 是否关闭窗口
     * }
     */
    handleError ({
      toastText = '出错了，稍后请重试',
      toastDuration = 3000,
      isCloseWindow = true
    }) {
      this.$toast(toastText, { toastDuration })
      setTimeout(() => {
        isCloseWindow && wx.closeWindow()
        // 关闭页面时，清除缓存
        isCloseWindow && sessionStorage.clear()
      }, toastDuration)
    },

    // 判断是否关闭页面
    handleIsReturnWindow () {
      const isReturn = sessionStorage.getItem(SESSION_STORAGE_PARAMS.isReturn)

      if (!isReturn) {
        sessionStorage.setItem(SESSION_STORAGE_PARAMS.isReturn, String(new Date().getTime()))
        return false
      }
      return true
    },

    // 缓存首次进入支付中间页的时间
    cacheTimeOfEnterPage () {
      // 首次进入页面，保存时间
      this.initEnterTime = sessionStorage.getItem(SESSION_STORAGE_PARAMS.enterTime)
      if (!this.initEnterTime) {
        sessionStorage.setItem(SESSION_STORAGE_PARAMS.enterTime, String(new Date().getTime()))
      }
    },

    // 上报页面加载时间
    reportPageLoader () {
      const endTime = new Date().getTime()

      // 时间差 - 秒级
      const timeDiffInSecond = (endTime - Number(this.initEnterTime)) / 1000

      // easyCounter加载时长上报
      useEasyCounter().gauge(EASYCOUNTER_METRIC.loadTimeGauge, timeDiffInSecond, { tryno: '3068' })

      // 报表上报页面加载时长
      this.reportPageLoaderTime(timeDiffInSecond)
      sessionStorage.removeItem(SESSION_STORAGE_PARAMS.enterTime)
    },

    // 报表 - H5页面加载时长上报
    reportPageLoaderTime (pageLoadTime) {
      // 测试上报的url
      const crab_infoc_url = this.getCrabInfocReportUrl()
      const { uuid, tid1, tid2, tod1, tod2, tryno, open_id } = this.common
      this.openid = open_id

      // 公共上报字段
      const commomInfo = {
        uuid: uuid,
        tid1: tid1,
        tid2: tid2,
        tod1: tod1,
        tod2: tod2,
        type: 0,
        tryno: tryno,
        iid: 0,
        collect_time: 0,
        lastver: 0,
        svrid: uuid,
        wtod2: '',
        usertype_public: 0,
      }

      // 业务字段
      const initData = {
        product_no: 1, // Infoc毒霸产品
        public_index: 6, // duba_public的index
        product_id: PRODUCT_ID.pdfVip,
        url: window.location.href.split('?')[0] || '',
        openid: this.openid,
        load_time: String(pageLoadTime),
        days: this.payParams.install_days,
        ver: REPORT_VERSION
      }

      const reportObj = useReporter(crab_infoc_url, 'duba_jgpdfpay_loadtime:8536 product_id:int url:string openid:string load_time:string days:string ver:string', initData, commomInfo)
      reportObj.report(initData)
    },

    // 获取crab_infoc上报的url
    getCrabInfocReportUrl () {
      const protocol = location.protocol || 'http:'
      let crab_infoc_url = `${protocol}//infoc2.duba.net/g/v1/`
      if (process.env.VUE_APP_STAGE === 'test') {
        crab_infoc_url = `${protocol}//121.37.228.14/g/v1/`
      }
      return crab_infoc_url
    },

    // 创建米大师支付
    createMidasOrder () {
      const commonParams = {
        common: this.common,
        ...this.payParams
      }

      if (this.payWay === PAY_WAY.STANDARD_MONTHLY) {
        createMidasOrderByStandardPackage(commonParams).then(res => {
          this.handlerOrderApiData(res)
        })
        return
      }
      createMidasOrderByTool(commonParams).then(res => {
        this.handlerOrderApiData(res)
      })
    },

    // 创建订单api数据处理
    handlerOrderApiData (res) {
      if (res.resp_common.ret != 0) {
        this.$toast(res.resp_common.msg)
        return
      }
      this.wx_openid = res.wx_open_id

      if (this.payWay === PAY_WAY.STANDARD_MONTHLY) {
        const { midas_package_id, order_id } = res.month_order_info
        this.pidOfMidas = midas_package_id
        this.orderId = order_id
      } else {
        const { param_url, order_id } = res.goods_pay_order_info
        this.paramUrl = param_url
        this.orderId = order_id
      }

      const params = {
        appid: this.appid, // 米大师的应用ID - 搜狗提供 道具 - 1450356157  标准 - 1450341278
        service: 'MBOSS4398', // 汇率 - 固定值
        pf: 'sogou_m-2001-html5-0000-0000', // 固定值 - 搜狗提供
        sandbox: process.env.VUE_APP_STAGE === 'test' ? 1 : 0, // 沙盒模式
        as: 1, // 固定传1
        dc: 'qqwallet,qqcard', // 屏蔽的支付方式
        productid: this.pidOfMidas, // 套餐ID - 搜狗提供&创建 - test1fen
        zoneid: '1', // 区服ID - 固定值
        account: 'dummy', // 账户体系 - 游客
        openid: this.common.open_id, // 极光侧的openid
        openkey: this.common.open_id, // 极光侧的openid
        sessionid: 'hy_gameid', // 固定值
        sessiontype: 'st_dummy', // 固定值 - 支付模式 -游客支付
        wxAppid: '1', // 固定值 - 搜狗提供
        wx_openid: this.wx_openid, // 微信授权的openid
        aid: this.orderId, // 订单ID - 服务端提供
      }

      if (this.payWay === PAY_WAY.STANDARD_MONTHLY) {
        this.callMidasOrderByStandardPackage(params)
      } else {
        this.callMidasOrderByTool(params)
      }
    },

    // 米大师 - 调用标准包月
    callMidasOrderByStandardPackage (data) {
      Midas.openSubscribe({
        ...data,
        onSuccess: function () {
          wx.closeWindow()
        },
        onClose: function () {
          wx.closeWindow()
        },
      })
    },

    // 米大师 - 调用道具直购
    callMidasOrderByTool (data) {
      Midas.buyGoods({
        ...data,
        params: this.paramUrl, // 服务端提供
        onSuccess: function () {
          wx.closeWindow()
        },
        onClose: function () {
          wx.closeWindow()
        },
      })
    },
  },
}
</script>
